
import { defineComponent } from "vue";
import { mapMutations, mapGetters } from "vuex";
import messages from "@/config/messages";
import * as apiClient from "@/apiclient/";
import common from "@/config/common";
import store from "@/store";

export default defineComponent({
  name: "DocumentUploadDragAndDrop",
  data() {
    return {
      files: [],
      validationMsg: "" as string,
      isDragging: false as boolean,
      state: {},
    };
  },
  methods: {
    handleFileChange(event: any) {
      this.files = event.target.files;
      this.uploadFile();
      event.target.value = null;
    },
    async uploadFile() {
      if (!this.files.length) return;
      if (this.notValidFileType()) {
        this.setShowModal(true);
        this.setModalTitle("Alert!");
        this.setModalContent(messages.notAllowedDocument);
        return;
      }

      this.setTotalFiles(this.files.length);
      const uploadedFiles = Array.from(this.files);
      var failedFile = false;

      for (let index = 0; index < uploadedFiles.length; index++) {
        var file = uploadedFiles[index] as any;
        this.setUploadedFiles(index + 1);
        this.setUploadFile({
          name: file.name,
          type: file.type,
          size: file.size,
          show: true,
          disabled: false,
        });
        const params: apiClient.PostApiDocumentMutationRequest = {
          File: file,
          customerParticipantId:
            this.getEnrollment.customerParticipantId.toString(),
        };
        const result = await apiClient
          .documentController()
          .postApiDocument(params);
        if (result.error) {
          failedFile = true;
          this.removeUploadProgress(index);
          this.removeUploadFile(index);
          this.validationMsg = result.error + messages.errorMsg;
          console.error("Error uploading file:", result.error);
          this.$emit("setValidationMessage", this.validationMsg);
        } else if (result.data) {
          const electionUploadId = result.data;
          const uploadedDoc = {
            fileName: file.name,
            electionUploadId,
            contentType: file.type,
            fileSize: file.size,
            disabled: false,
          };

          this.setDocumentsUploaded([
            ...this.getDocumentsUploaded,
            uploadedDoc,
          ]);
          this.setDocumentSubmitBtn(common.saveNext);
        }
      }

      this.setTotalFiles(0);
      this.setUploadedFiles(0);
      this.removeUploadFiles();

      if (!failedFile) {
        this.$emit("setValidationMessage", "");
      }
    },
    notValidFileType() {
      const allowedFileTypes = [
        "image/tiff",
        "image/bmp",
        "image/png",
        "image/jpeg",
        "application/pdf",
      ];

      return Array.from(this.files).some(
        (file: File) => allowedFileTypes.indexOf(file.type) === -1
      );
    },
    handleDrop(event: any) {
      event.preventDefault();
      this.files = event.dataTransfer.files;
      this.isDragging = false;

      this.uploadFile();
      event.target.value = null;
    },
    ...mapMutations([
      "setUploadFile",
      "setTotalFiles",
      "setUploadedFiles",
      "removeUploadFile",
      "removeUploadFiles",
      "setShowModal",
      "setModalTitle",
      "setModalContent",
      "setDocumentsUploaded",
      "removeUploadProgress",
      "setDocumentSubmitBtn",
    ]),
  },
  computed: {
    ...mapGetters([
      "getDocumentSubmitBtn",
      "getDocumentsUploaded",
      "getEnrollment",
    ]),
  },
});
